module.exports = __webpack_public_path__ + "img/casher-goods-amount-icon.a74efc65.png";